module.exports = __webpack_public_path__ + "img/carrousel-rad-digi-sala-8.d1b79589.png";